import type { RequestConfig } from '@customTypes/index';
import type { WorkInviteItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type RejectWorkInvite = {
  workInviteId: string;
};

export type RejectWorkInviteParams = RequestConfig<RejectWorkInvite>;

export const rejectWorkInvite = async ({
  params,
  config
}: RejectWorkInviteParams) =>
  api.post<WorkInviteItemDto>(
    `/api/work/invites/${params.workInviteId}/reject`,
    config
  );
